/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import PropTypes from 'prop-types'


export default function S3DownloadModal(props) {
  const s3Url = `s3://${props.row.bucket}/${props.row.key}`
  const httpsUrl = `https://${props.row.bucket}.s3-us-west-2.amazonaws.com/${props.row.key}`

  return (
    <Modal {...props} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Published S3 Download URLs</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h3>Your files are available at the following URLs:</h3>
        <br/>
        <p><a href={s3Url}>{s3Url}</a></p>
        <p><a href={httpsUrl}>{httpsUrl}</a></p>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  )
}

S3DownloadModal.propTypes = {
  row: PropTypes.shape({
    cuid: PropTypes.string,
    bucket: PropTypes.string,
    key: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.string,
    scrapeMetadata: PropTypes.any,
    status: PropTypes.shape({
      scanPassed: PropTypes.bool
    })
  }),
  itemId: PropTypes.string,
  onHide: PropTypes.func,
}